// =============================================================================
// MeuDriver — Agenda Availability Editor (weekly recurring slots)
// =============================================================================

import { Save } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { DAY_OF_WEEK_LABELS } from '@/lib/constants'
import type { WeekAvailability } from './AgendaWeekGrid'

interface Props {
  availability: WeekAvailability
  saving: boolean
  onChange: (next: WeekAvailability) => void
  onSave: () => void
}

export function AgendaAvailabilityEditor({ availability, saving, onChange, onSave }: Props) {
  function patch(dow: number, partial: Partial<{ enabled: boolean; start_time: string; end_time: string }>) {
    onChange({ ...availability, [dow]: { ...availability[dow], ...partial } })
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Gerenciar disponibilidade</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {[1, 2, 3, 4, 5, 6, 0].map((dow) => {
          const avail = availability[dow]
          return (
            <div key={dow} className="space-y-1.5">
              <div className="flex items-center justify-between">
                <Label className="text-sm font-medium">{DAY_OF_WEEK_LABELS[dow]}</Label>
                <Switch
                  checked={avail.enabled}
                  onCheckedChange={(checked) => patch(dow, { enabled: checked })}
                />
              </div>
              {avail.enabled && (
                <div className="flex items-center gap-2 pl-0">
                  <Input
                    type="time"
                    value={avail.start_time}
                    onChange={(e) => patch(dow, { start_time: e.target.value })}
                    className="h-8 text-xs"
                  />
                  <span className="text-muted-foreground text-xs">até</span>
                  <Input
                    type="time"
                    value={avail.end_time}
                    onChange={(e) => patch(dow, { end_time: e.target.value })}
                    className="h-8 text-xs"
                  />
                </div>
              )}
            </div>
          )
        })}

        <Button className="w-full mt-2" onClick={onSave} disabled={saving}>
          <Save className="h-4 w-4 mr-2" />
          {saving ? 'Salvando...' : 'Salvar disponibilidade'}
        </Button>
      </CardContent>
    </Card>
  )
}
